document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('.collection-list .card');

  cards.forEach(function(card) {
    var link = card.querySelector('a[href*="/collections/"]');
    var img = card.querySelector('img');

    if (link && img) {
      // Si la imagen no está dentro de un <a>, la envolvemos
      if (!img.closest('a')) {
        var a = document.createElement('a');
        a.href = link.href;
        a.className = 'collection-image-link';

        img.parentNode.insertBefore(a, img);
        a.appendChild(img);
      } else {
        // Si ya está dentro de un <a>, asegurar que apunte al link correcto
        img.closest('a').href = link.href;
      }
    }
  });
});
